import { useMemo } from 'react';
import type { DmScanPhoto } from './types';

export interface ScanPhotoCarousel {
    images: string[];
    labels: string[];
    thumbnails: string[];
    steps: string[];
}

// The carousel indexes images, labels, thumbnails and steps together, so all are
// derived from one filtered array — a photo missing both URLs is dropped.
export function useScanPhotos(photos: DmScanPhoto[] | null | undefined): ScanPhotoCarousel {
    return useMemo(() => {
        const usable = (photos ?? []).flatMap((photo) => {
            const full = photo.originalUrl ?? photo.previewUrl;
            if (full === null) return [];
            return [
                { step: photo.step, label: photo.label, full, thumbnail: photo.previewUrl ?? full }
            ];
        });
        return {
            images: usable.map((photo) => photo.full),
            labels: usable.map((photo, i) => `${photo.label} ${i + 1}/${usable.length}`),
            thumbnails: usable.map((photo) => photo.thumbnail),
            steps: usable.map((photo) => photo.step)
        };
    }, [photos]);
}
